import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { XTabNav } from '@/components/xqxc_ui';
import AccountList from './accountlist';
import { RoleType } from './types';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const tabList = [
    { id: RoleType.USER, label: '服务费帐户' }
];

const Detail = (props) => {

    const [curTabID, setCurTabID] = useState(RoleType.USER);

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            {curTabID === RoleType.USER && <AccountList curTabID={curTabID} {...props} />}
        </div>
    );
};

Detail.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Detail);